// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colori del prototipo "Demo Onboarding Flusso Prova", come la chat del desktop. */
.dcm-header ion-toolbar {
  --background: #fff;
  --border-width: 0 0 1px 0;
  --border-color: #e4e6ef;
  --min-height: 58px;
  --padding-start: 0;
  --padding-end: 0;
}

.dcm-testa {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 6px 10px 14px;
}

.dcm-avatar {
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #212c5f;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* La mascotte, come nella chat del desktop: una goccia arancione con due occhi. */
.dcm-goccia {
  display: block;
  width: 20px;
  height: 22px;
  background: #f25c04;
  border-radius: 48% 48% 42% 42%/62% 62% 34% 34%;
  position: relative;
}
.dcm-goccia i {
  position: absolute;
  left: 7px;
  top: 8px;
  width: 2.5px;
  height: 5px;
  background: #000;
  border-radius: 1.5px;
}
.dcm-goccia i.destro {
  left: auto;
  right: 7px;
}

.dcm-chi {
  flex: 1;
  min-width: 0;
}

.dcm-nome {
  font-size: 14.5px;
  font-weight: 800;
  color: #212c5f;
}

.dcm-stato {
  font-size: 11px;
  color: #5a6a8a;
}

.dcm-chiudi {
  --color: #5a6a8a;
  margin: 0;
}

.dcm-flusso {
  --background: #f9fafb;
}

.dcm-messaggi {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.dcm-riga {
  display: flex;
}
.dcm-riga.io {
  justify-content: flex-end;
}
.dcm-riga.sistema {
  justify-content: center;
}

.dcm-bolla {
  max-width: 82%;
  padding: 9px 12px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
}
.dcm-bolla.bot {
  background: #fff;
  border: 1px solid #e4e6ef;
  color: #212c5f;
}
.dcm-bolla.io {
  background: #2f6bff;
  color: #fff;
}
.dcm-bolla.sistema {
  background: #fff4e5;
  color: #8a5a00;
  font-size: 12.5px;
}

.dcm-piede {
  background: #f9fafb;
  /* la riga d'ombra di Ionic qui non serve */
}
.dcm-piede::before {
  display: none;
}

.dcm-azioni {
  padding: 8px 12px 0;
  background: #f9fafb;
}
.dcm-azioni .dcm-prova {
  --background: #f25c04;
  --color: #fff;
  --border-radius: 14px;
  font-weight: 800;
  margin: 0;
}

.dcm-form {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
  background: #f9fafb;
  border-top: 1px solid #e4e6ef;
}
.dcm-form input {
  flex: 1;
  min-width: 0;
  height: 42px;
  border: 1px solid #e4e6ef;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 16px; /* sotto i 16px iOS ingrandisce la pagina da solo */
  font-family: inherit;
  color: #212c5f;
  outline: none;
  background: #fff;
}
.dcm-form .dcm-invia {
  --background: #2f6bff;
  --border-radius: 10px;
  font-weight: 800;
  margin: 0;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/demo-chat/demo-chat.component.scss"],"names":[],"mappings":"AAAA,mFAAA;AAQA;EACE,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBA5BO;EA6BP,aAAA;EACA,mBAAA;EACA,uBAAA;AANF;;AASA,kFAAA;AACA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBArCO;EAsCP,8CAAA;EACA,kBAAA;AANF;AAQE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AANJ;AAQI;EAAW,UAAA;EAAY,UAAA;AAJ3B;;AAQA;EAAa,OAAA;EAAS,YAAA;AAHtB;;AAIA;EAAa,iBAAA;EAAmB,gBAAA;EAAkB,cAzDzC;AA2DT;;AADA;EAAa,eAAA;EAAiB,cAzDrB;AA+DT;;AAJA;EACE,gBAAA;EACA,SAAA;AAOF;;AAJA;EACE,qBAAA;AAOF;;AAJA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAOF;;AAJA;EACE,aAAA;AAOF;AALE;EAAY,yBAAA;AAQd;AAPE;EAAY,uBAAA;AAUd;;AAPA;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAUF;AARE;EAAY,gBAAA;EAAkB,yBAAA;EAAyB,cA3FhD;AAwGT;AAZE;EAAY,mBAzFL;EAyFuB,WAAA;AAgBhC;AAfE;EAAY,mBAAA;EAAqB,cAAA;EAAgB,iBAAA;AAoBnD;;AAjBA;EACE,mBAAA;EAE+B,2CAAA;AAmBjC;AAnBE;EAAY,aAAA;AAsBd;;AAnBA;EACE,mBAAA;EACA,mBAAA;AAsBF;AApBE;EACE,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;AAsBJ;;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2DAAA;EACA,mBAAA;EACA,6BAAA;AAqBF;AAnBE;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA,EAAA,mDAAA;EACA,oBAAA;EACA,cApIK;EAqIL,aAAA;EACA,gBAAA;AAqBJ;AAlBE;EACE,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;AAoBJ;AACA,wzLAAwzL","sourcesContent":["/* Colori del prototipo \"Demo Onboarding Flusso Prova\", come la chat del desktop. */\n$navy:   #212c5f;\n$grigio: #5a6a8a;\n$arancio:#f25c04;\n$blu:    #2f6bff;\n$riga:   #e4e6ef;\n$verde:  #29c366;\n\n.dcm-header ion-toolbar {\n  --background: #fff;\n  --border-width: 0 0 1px 0;\n  --border-color: #{$riga};\n  --min-height: 58px;\n  --padding-start: 0;\n  --padding-end: 0;\n}\n\n.dcm-testa {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 6px 10px 14px;\n}\n\n.dcm-avatar {\n  width: 38px;\n  height: 38px;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  background: $navy;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* La mascotte, come nella chat del desktop: una goccia arancione con due occhi. */\n.dcm-goccia {\n  display: block;\n  width: 20px;\n  height: 22px;\n  background: $arancio;\n  border-radius: 48% 48% 42% 42% / 62% 62% 34% 34%;\n  position: relative;\n\n  i {\n    position: absolute;\n    left: 7px;\n    top: 8px;\n    width: 2.5px;\n    height: 5px;\n    background: #000;\n    border-radius: 1.5px;\n\n    &.destro { left: auto; right: 7px; }\n  }\n}\n\n.dcm-chi   { flex: 1; min-width: 0; }\n.dcm-nome  { font-size: 14.5px; font-weight: 800; color: $navy; }\n.dcm-stato { font-size: 11px; color: $grigio; }\n\n.dcm-chiudi {\n  --color: #{$grigio};\n  margin: 0;\n}\n\n.dcm-flusso {\n  --background: #f9fafb;\n}\n\n.dcm-messaggi {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.dcm-riga {\n  display: flex;\n\n  &.io      { justify-content: flex-end; }\n  &.sistema { justify-content: center; }\n}\n\n.dcm-bolla {\n  max-width: 82%;\n  padding: 9px 12px;\n  border-radius: 12px;\n  font-size: 14px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n\n  &.bot     { background: #fff; border: 1px solid $riga; color: $navy; }\n  &.io      { background: $blu; color: #fff; }\n  &.sistema { background: #fff4e5; color: #8a5a00; font-size: 12.5px; }\n}\n\n.dcm-piede {\n  background: #f9fafb;\n\n  &::before { display: none; }   /* la riga d'ombra di Ionic qui non serve */\n}\n\n.dcm-azioni {\n  padding: 8px 12px 0;\n  background: #f9fafb;\n\n  .dcm-prova {\n    --background: #{$arancio};\n    --color: #fff;\n    --border-radius: 14px;\n    font-weight: 800;\n    margin: 0;\n  }\n}\n\n.dcm-form {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));\n  background: #f9fafb;\n  border-top: 1px solid $riga;\n\n  input {\n    flex: 1;\n    min-width: 0;\n    height: 42px;\n    border: 1px solid $riga;\n    border-radius: 10px;\n    padding: 0 12px;\n    font-size: 16px;      /* sotto i 16px iOS ingrandisce la pagina da solo */\n    font-family: inherit;\n    color: $navy;\n    outline: none;\n    background: #fff;\n  }\n\n  .dcm-invia {\n    --background: #{$blu};\n    --border-radius: 10px;\n    font-weight: 800;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
